import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function CommercialSummaryCard({
  modifyData, companyData, policyEffectiveDate, customer,
}) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <Card>
      <Header>
        <Title>Impresa</Title>
        {modifyData && (
          <ModificaButton type="button" onClick={modifyData}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>{companyData?.business_name}</CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Nome Compagnia</dt>
              <dd>{companyData?.business_name}</dd>
            </InfoRow>
            {customer && customer?.gender !== 'G' && (
              <InfoRow>
                <dt>Cliente</dt>
                <dd>
                  {customer?.name}
                  {' '}
                  {customer?.surname}
                </dd>
              </InfoRow>
            )}
            <InfoRow>
              <dt>Numero Compagnia</dt>
              <dd>{companyData?.company_number ?? '-'}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Partita IVA</dt>
              <dd>{customer ? customer.vat_number : companyData?.vat_number}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Numero di Dipendenti</dt>
              <dd>{companyData?.alter_summary_employees_nr ?? '-'}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(policyEffectiveDate).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default CommercialSummaryCard;
